var _rect, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserListingActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1296_2330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1296_2330)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5557 14.2368C17.8115 14.4477 19.1957 14.2277 20.1673 13.5768C21.4598 12.7152 21.4598 11.3035 20.1673 10.4418C19.1865 9.791 17.784 9.571 16.5282 9.791M7.41649 14.2368C6.16066 14.4477 4.77649 14.2277 3.80482 13.5768C2.51232 12.7152 2.51232 11.3035 3.80482 10.4418C4.78566 9.791 6.18816 9.571 7.44399 9.791M17.4998 7.5635C17.4421 7.55432 17.3834 7.55432 17.3257 7.5635C16.7139 7.54137 16.1347 7.28227 15.7105 6.84094C15.2863 6.39962 15.0503 5.81065 15.0523 5.1985C15.0523 3.88766 16.1065 2.8335 17.4173 2.8335C18.0446 2.8335 18.6461 3.08267 19.0896 3.52619C19.5332 3.96971 19.7823 4.57126 19.7823 5.1985C19.7806 5.81108 19.5422 6.39929 19.1167 6.84007C18.6913 7.28086 18.112 7.54007 17.4998 7.5635ZM6.47232 7.5635C6.52732 7.55433 6.59149 7.55433 6.64649 7.5635C7.25824 7.54137 7.83743 7.28227 8.26165 6.84094C8.68587 6.39962 8.92189 5.81065 8.91982 5.1985C8.91982 3.88766 7.86566 2.8335 6.55482 2.8335C5.92759 2.8335 5.32604 3.08267 4.88252 3.52619C4.43899 3.96971 4.18982 4.57126 4.18982 5.1985C4.19899 6.48183 5.20732 7.51766 6.47232 7.5635ZM11.9998 14.411C11.9421 14.4018 11.8834 14.4018 11.8257 14.411C11.2139 14.3889 10.6347 14.1298 10.2105 13.6884C9.78628 13.2471 9.55026 12.6581 9.55232 12.046C9.55232 10.7352 10.6065 9.681 11.9173 9.681C12.5446 9.681 13.1461 9.93016 13.5896 10.3737C14.0332 10.8172 14.2823 11.4188 14.2823 12.046C14.2732 13.3293 13.2648 14.3743 11.9998 14.411ZM9.33232 17.2985C8.03982 18.1602 8.03982 19.5718 9.33232 20.4335C10.799 21.4143 13.2007 21.4143 14.6673 20.4335C15.9598 19.5718 15.9598 18.1602 14.6673 17.2985C13.2098 16.3268 10.799 16.3268 9.33232 17.2985Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserListingActive);
export default __webpack_public_path__ + "static/media/user-listing-active.d60abffe514a58ab221aff087db79105.svg";
export { ForwardRef as ReactComponent };